export const footerMoreLinks = {
  'kg-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://kg.wingie.com/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://kg.wingie.com/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://kg.wingie.com/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://kg.wingie.com/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://kg.wingie.com/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://kg.wingie.com/awards/',
          title: 'Награды',
        },
      ],
    },
  ],
  'kg-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://kg.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://kg.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://kg.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://kg.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kg.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://kg.wingie.com/en/awards/',
          title: 'Awards',
        },
      ],
    },
  ],
  'kg-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://kg.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://kg.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://kg.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://kg.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://kg.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://kg.wingie.com/es/awards/',
          title: 'Premios',
        },
      ],
    },
  ],
  'kg-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://kg.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://kg.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen',
        },

        {
          href: 'https://kg.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://kg.wingie.com/de/datenschutz/',
          title: 'Datenschutz',
        },
        {
          href: 'https://kg.wingie.com/de/allgemeine-geschaftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://kg.wingie.com/de/awards/',
          title: 'Preise',
        },
      ],
    },
  ],
  'kg-ar': [
    {
      title: 'المزيد',
      items: [
        {
          href: 'https://kg.wingie.com/ar/contact/',
          title: 'اتصل بنا',
        },
        {
          href: 'https://kg.wingie.com/ar/faq/',
          title: 'الأسئلة الشائعة',
        },

        {
          href: 'https://kg.wingie.com/ar/about-us/',
          title: 'من نحن',
        },
        {
          href: 'https://kg.wingie.com/ar/privacy/',
          title: 'الخصوصية',
        },
        {
          href: 'https://kg.wingie.com/ar/terms-and-conditions/',
          title: 'الشروط والأحكام',
        },
        {
          href: 'https://kg.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'kg-it': [
    {
      title: 'Altro',
      items: [
        {
          href: 'https://kg.wingie.com/it/contact/',
          title: 'Contatto',
        },
        // {
        //     href: 'https://kg.wingie.com/it/faq/',
        //     title: 'Domande frequenti',
        // },

        {
          href: 'https://kg.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://kg.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kg.wingie.com/it/terms-and-conditions/',
          title: 'Termini e condizioni',
        },
        {
          href: 'https://kg.wingie.com/it/awards/',
          title: 'Premi',
        },
      ],
    },
  ],
  'kg-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://kg.wingie.com/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kg.wingie.com/fr/faq/',
        //     title: 'Questions fréquemment posées',
        // },

        {
          href: 'https://kg.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://kg.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://kg.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et conditions',
        },
        {
          href: 'https://kg.wingie.com/fr/awards/',
          title: 'Prix',
        },
      ],
    },
  ],
  'kg-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://kg.wingie.com/pt/contact/',
          title: 'Contacto',
        },
        // {
        //     href: 'https://kg.wingie.com/pt/faq/',
        //     title: 'Perguntas frequentes',
        // },

        {
          href: 'https://kg.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://kg.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://kg.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e condições',
        },
        {
          href: 'https://kg.wingie.com/pt/awards/',
          title: 'Prémios',
        },
      ],
    },
  ],
  'kg-ro': [
    {
      title: 'Mai mult',
      items: [
        {
          href: 'https://kg.wingie.com/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kg.wingie.com/ro/faq/',
        //     title: 'Întrebări frecvente',
        // },

        {
          href: 'https://kg.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://kg.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://kg.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și condiții',
        },
        {
          href: 'https://kg.wingie.com/ro/awards/',
          title: 'Premii',
        },
      ],
    },
  ],
  'kg-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://kg.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://kg.wingie.com/pl/faq/',
        //     title: 'Najczęściej zadawane pytania',
        // },

        {
          href: 'https://kg.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://kg.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://kg.wingie.com/pl/terms-and-conditions/',
          title: 'Regulamin',
        },
        {
          href: 'https://kg.wingie.com/pl/awards/',
          title: 'Nagrody',
        },
      ],
    },
  ],
  'kg-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://kg.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://kg.wingie.com/lt/faq/',
        //     title: 'Dažnai užduodami klausimai',
        // },

        {
          href: 'https://kg.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://kg.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://kg.wingie.com/lt/terms-and-conditions/',
          title: 'Taisyklės ir sąlygos',
        },
        {
          href: 'https://kg.wingie.com/lt/awards/',
          title: 'Prizai',
        },
      ],
    },
  ],
  'kg-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://kg.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://kg.wingie.com/uz/faq/',
        //     title: 'Tez-tez beriladigan savollar',
        // },

        {
          href: 'https://kg.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://kg.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://kg.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar va qoidalar',
        },
        {
          href: 'https://kg.wingie.com/uz/awards/',
          title: 'Mukofotlar',
        },
      ],
    },
  ],
  'kg-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://kg.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        // {
        //     href: 'https://kg.wingie.com/sr/faq/',
        //     title: 'Често постављана питања',
        // },

        {
          href: 'https://kg.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://kg.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://kg.wingie.com/sr/terms-and-conditions/',
          title: 'Услови и одредбе',
        },
        {
          href: 'https://kg.wingie.com/sr/awards/',
          title: 'Награде',
        },
      ],
    },
  ],
  'kg-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://kg.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://kg.wingie.com/ky/faq/',
        //     title: 'Көп берилүүчү суроолор',
        // },

        {
          href: 'https://kg.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://kg.wingie.com/ky/privacy/',
          title: 'Купуялык',
        },
        {
          href: 'https://kg.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар жана эрежелер',
        },
        {
          href: 'https://kg.wingie.com/ky/awards/',
          title: 'Мурадлар',
        },
      ],
    },
  ],
  'kg-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://kg.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://kg.wingie.com/tg/faq/',
        //     title: 'Саволҳои зиёд пурсидашуда',
        // },

        {
          href: 'https://kg.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://kg.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://kg.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо ва қоидаҳо',
        },
        {
          href: 'https://kg.wingie.com/tg/awards/',
          title: 'Мурадлар',
        },
      ],
    },
  ],
  'kg-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://kg.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        // {
        //     href: 'https://kg.wingie.com/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },

        {
          href: 'https://kg.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://kg.wingie.com/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://kg.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://kg.wingie.com/kk/awards/',
          title: 'Біздің марапаттарымыз',
        },
      ],
    },
  ],
  'kg-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://kg.wingie.com/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kg.wingie.com/nl/faq/',
        //     title: 'Veelgestelde vragen',
        // },

        {
          href: 'https://kg.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://kg.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kg.wingie.com/nl/terms-and-conditions/',
          title: 'Algemene voorwaarden',
        },
        {
          href: 'https://kg.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'kg-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://kg.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://kg.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://kg.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://kg.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://kg.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://kg.wingie.com/ja/awards/' },
      ],
    },
  ],
  'kg-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://kg.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://kg.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://kg.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://kg.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://kg.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://kg.wingie.com/zh/awards/' },
      ],
    },
  ],
  'kg-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://kg.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://kg.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://kg.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://kg.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://kg.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://kg.wingie.com/ko/awards/' },
      ],
    },
  ],
  'kg-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://kg.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://kg.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://kg.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://kg.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://kg.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://kg.wingie.com/hi/awards/' },
      ],
    },
  ],
  'kg-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://kg.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://kg.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://kg.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://kg.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://kg.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://kg.wingie.com/ta/awards/' },
      ],
    },
  ],
  'kg-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://kg.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://kg.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://kg.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://kg.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://kg.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://kg.wingie.com/th/awards/' },
      ],
    },
  ],
  'kg-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://kg.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://kg.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://kg.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://kg.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://kg.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://kg.wingie.com/ur/awards/' },
      ],
    },
  ],
  'kg-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://kg.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://kg.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://kg.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://kg.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://kg.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://kg.wingie.com/ka/awards/' },
      ],
    },
  ],
}
